module.exports = __webpack_public_path__ + "static/media/Bluelab Leap pH Probe.430b85c0.webp";